


























































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import type { Company } from '@/models/company';
import type { Project } from '@/models/project';
import { projectWebservice } from '@/webservices/project';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { getUniqueByKey } from '@/helpers/getUniqueByKey';

@Component({
    name: 'ProjectsList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { getUniqueByKey, hasPermission },
})
export default class ProjectsList extends Vue {
    private tableSettings = {
        perPage: 50,
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    private loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    private projects = new Array<Project>();

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/company') private userCompany: Company;

    private mounted() {
        this.$store.commit('utils/setCurrentRoutePath', '/system/company-projects');
        this.loadProjects();
    }

    private loadProjects() {
        this.loading.data = true;
        projectWebservice
            .loadAllByCompany()
            .then((response) => {
                this.projects = response.data;
                this.loading.data = false;
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
